module.exports = __webpack_public_path__ + "static/media/icon-advisory-committee-2.bee3c316.svg";